
import { callServer } from 'next/dist/client/app-call-server'

function __build_action__(action, args) {
  return callServer(action.$$id, args)
}

/* __next_internal_action_entry_do_not_use__ {"0860565db9d0d1fd03bc5bc738907dcacecc371c":"CancelSubscription","2a23cba9196e9b376095639483de69cd4926ed6d":"ResumeSubscription","3ce537d29e684e6a135f99936f80c421ea20d494":"CheckSubscription","95d2ed2cec9a5be9d0c85408817007f05433e8c4":"FetchOrCreateCustomer","9639922713a9a1de0e78ec058bdaf99e099aa2ca":"GetPrices","a6e111f1fd041f660c13ad5c892f1c07703fa94d":"CreateClient","b4b3bdae26f2a1654477219f112fb4710234aaa4":"GetProduct"} */ export var GetPrices = createServerReference("9639922713a9a1de0e78ec058bdaf99e099aa2ca");
import { createServerReference } from "private-next-rsc-action-client-wrapper";
export var CreateClient = createServerReference("a6e111f1fd041f660c13ad5c892f1c07703fa94d");
export var FetchOrCreateCustomer = createServerReference("95d2ed2cec9a5be9d0c85408817007f05433e8c4");
export var CheckSubscription = createServerReference("3ce537d29e684e6a135f99936f80c421ea20d494");
export var GetProduct = createServerReference("b4b3bdae26f2a1654477219f112fb4710234aaa4");
export var CancelSubscription = createServerReference("0860565db9d0d1fd03bc5bc738907dcacecc371c");
export var ResumeSubscription = createServerReference("2a23cba9196e9b376095639483de69cd4926ed6d");

